import type { DrawerState, DrawerPosition } from '@app/shared/types/drawer'
import { RightDrawerContent } from '@app/shared/types/drawer'

export default (doc: Document): Array<() => void> => {
  const unsubscribers: Array<() => void> = []

  const mainWrapper = doc.getElementById('main-wrapper')
  const rightDrawer = doc.getElementById('right-drawer')

  const collapseDrawer = (modifier: DrawerPosition): void => {
    window.requestAnimationFrame(() => {
      if (mainWrapper) {
        mainWrapper.dataset[`${modifier}Drawer`] = 'collapsed'
      }
    })
  }

  const expandDrawer = (modifier: DrawerPosition): void => {
    window.requestAnimationFrame(() => {
      if (mainWrapper) {
        mainWrapper.dataset[`${modifier}Drawer`] = 'expanded'
      }
    })
  }

  const handleDrawerOpen = (drawer: DrawerState): void => {
    if (drawer.direction !== 'left' && drawer.direction !== 'right') {
      return
    }

    window.requestAnimationFrame(() => {
      if (rightDrawer && drawer.direction === 'right') {
        if (
          [
            RightDrawerContent.FilePreview,
            RightDrawerContent.FileAttachments,
          ].includes(drawer.content)
        ) {
          rightDrawer.classList.add('sidebar-large')
        } else {
          rightDrawer.classList.remove('sidebar-large')
        }

        // The talking-points drawer (presentation mode) is full-height above the
        // top nav and pushes the page left; the styles key off
        // data-right-drawer-overlay on the wrapper (see two-drawer-layout-new.scss).
        if (mainWrapper) {
          if (drawer.content === RightDrawerContent.TalkingPoints) {
            mainWrapper.dataset.rightDrawerOverlay = 'true'
          } else {
            delete mainWrapper.dataset.rightDrawerOverlay
          }
        }
      }
    })

    expandDrawer(drawer.direction)
  }

  const handleDrawerClose = (direction?: DrawerPosition): void => {
    if (!direction) {
      return
    }

    collapseDrawer(direction)

    if (rightDrawer && direction === 'right') {
      window.requestAnimationFrame(() => {
        rightDrawer.classList.remove('sidebar-large')
        // Release the presentation-mode overlay so the drawer stops being
        // fixed/high-z-index once it's collapsed (see two-drawer-layout-new.scss).
        if (mainWrapper) {
          delete mainWrapper.dataset.rightDrawerOverlay
        }
      })
    }
  }

  window.eventHub.$on('drawer:open', handleDrawerOpen)
  window.eventHub.$on('drawer:close', handleDrawerClose)

  window.eventHub.$emit('drawer:ready')
  window.eventHub.$emit('drawer:animation-end')

  unsubscribers.push(() => {
    window.eventHub.$off('drawer:open', handleDrawerOpen)
    window.eventHub.$off('drawer:close', handleDrawerClose)
  })

  return unsubscribers
}
